import { ChangeEvent, useState } from "react";
import { Email } from "../../assets/svg";

const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const EmailEntry = ({
    email,
    setEmail,
    setEmailIsValid,
    style,
}: {
    email: string;
    setEmail: React.Dispatch<React.SetStateAction<string>>;
    setEmailIsValid?: (x: boolean) => void;
    style?: React.CSSProperties;
}) => {
    const [emailValid, setEmailValid] = useState(false);
    const [emailValidatorBounce, setEmailValidatorBounce] =
        useState<NodeJS.Timeout | null>(null);

    const emailChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (emailValidatorBounce) {
            clearTimeout(emailValidatorBounce);
            setEmailValidatorBounce(null);
        }

        const val = e.target.value;

        const timeout = setTimeout(() => {
            const emailValid = emailRegex.test(val);
            setEmailValid(emailValid);

            setEmailIsValid && setEmailIsValid(emailValid);

            setEmailValidatorBounce(null);
        }, 500);

        setEmailValidatorBounce(timeout);
        setEmail(val);
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "stretch",
                ...style,
            }}
        >
            <div
                style={{
                    backgroundColor: "white",
                    display: "flex",
                    alignItems: "center",
                    borderRight: "1px solid lightgray",
                    paddingInline: "0.3em",
                }}
            >
                <Email size="sm" fill="black" />
            </div>
            <form>
                <input
                    type="email"
                    placeholder="Email"
                    name="questie-email"
                    style={{
                        color: "black",
                        backgroundColor:
                            emailValid ||
                            emailValidatorBounce ||
                            email.length === 0
                                ? ""
                                : "red",
                        padding: "0.5em",
                        border: "none",
                    }}
                    value={email}
                    onChange={(e) => emailChange(e)}
                />
            </form>
        </div>
    );
};
